<aside [ngStyle]="{ display: menuOpen ? 'block' : 'none' }"
  class="animate__animated animate__fadeIn w-50 h-full bg-white  min-h-[92.5vh] absolute border-r z-[900] py-4 mr-1 xl:static shadow-lg xl:!block">
  <ul class=" mb-16">
    @for (route of routenavigators; track route) {
    <li>
      <button [routerLink]="route.url" brnToggle class="w-[100%] h-16 flex flex-col items-center justify-center mb-2 !rounded-none shadow-(4px 4px 4px 0px)"
        [isActive]="route.state" hlm>
        <ng-icon size="2rem" [name]="route.icon_name"></ng-icon>
        <span class="font-normal">{{ route.nombre }}</span>
      </button>
    </li>
    }

    <li>
      <button routerLink="/logout" hlmToggle class="toogle w-[95%] h-14 flex items-center justify-start my-1 sm:hidden"
        hlm>
        <ng-icon class="w-5 h-5 mr-2" name="lucideBell" />
        <span>Notificaciones</span>
      </button>
    </li>
    <li>
      <button (click)="logOffTheWeb()" routerLink="/logout" hlmToggle
        class="toogle w-[95%] h-14 items-center justify-start my-1 sm:hidden flex" hlm>
        <ng-icon class="w-5 h-5 mr-2" name="lucideXCircle" />
        <span>Cerrar Sesión</span>
      </button>
    </li>
  </ul>
  @if (_accessByRole(["ROLE_CLIENTE_CHECKOUT"])) {
  <button routerLink="/checkout/close" hlmBtn
    class="button w-[95%] h-9 flex items-center justify-center bg-[#ED6C43] text-white">
    Cierre de caja
  </button>
  }
</aside>
